var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHelpDefault = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 7.25a2.4 2.4 0 0 0-2.4 2.4.6.6 0 0 1-1.2 0 3.6 3.6 0 0 1 7.2 0c0 1.36-.902 2.22-1.603 2.887l-.082.08c-.772.738-1.315 1.307-1.315 2.205a.6.6 0 1 1-1.2 0c0-1.46.939-2.358 1.664-3.052l.021-.02c.79-.756 1.315-1.282 1.315-2.1a2.4 2.4 0 0 0-2.4-2.4M12 17.913a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M1 12C1 5.933 5.933 1 12 1s11 4.933 11 11-4.933 11-11 11S1 18.067 1 12m11-9.8c-5.404 0-9.8 4.396-9.8 9.8s4.396 9.8 9.8 9.8 9.8-4.396 9.8-9.8-4.396-9.8-9.8-9.8",
  clipRule: "evenodd"
})));
export { SvgIconHelpDefault as ReactComponent };